import React from 'react';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import Spinner from '../Spinner';

interface ISpinnerWithReduxProps {
	size?: number;
	spinnerId?: number;
	spinnerColorId?: number;
}

const UserSpinner = ({
	size,
	spinnerId,
	spinnerColorId,
}: ISpinnerWithReduxProps) => {
	const { branding } = useAppSelector(auth);

	const isSpinnerIdProps = spinnerId !== undefined && spinnerColorId !== undefined;

	return (
		<Spinner
			size={size}
			spinnerColorId={isSpinnerIdProps ? spinnerColorId : branding?.spinnerColorId}
			spinnerId={isSpinnerIdProps ? spinnerId : branding?.spinnerId}
		/>
	);
};

export default UserSpinner;
